/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <v-snackbar v-model="snackbar" :timeout="6000" :color="iconStatus" bottom left id="snackbar">{{ snackbarMessage }}
    </v-snackbar>
    <v-layout row :wrap="!$vuetify.breakpoint.mdAndUp" :class="{'fill-height' : $vuetify.breakpoint.mdAndUp}">
      <v-flex xs12 md9 order-xs2 order-md1 mb-3 :class="{'fill-height': $vuetify.breakpoint.lgAndUp}">
        <AlertList :itemPerPage="itemPerPage" />
      </v-flex>
      <v-flex xs12 md3 order-xs1 order-md2 mb-3 class="fill-height section-width">
        <AlertSelection />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
const momentTz = require('moment-timezone')
import AlertList from '@/components/Alert-v2/AlertList'
import AlertSelection from '@/components/Alert-v2/AlertSelection'

import { EventBus } from '@/services/event-bus'
import { mixin } from '@/util/mixin/index'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    AlertList,
    AlertSelection
  },
  mixins: [ mixin ],
  data() {
    return {
      snackbarMessage: 'Test',
      snackbar: false,
      iconStatus: 'info',
      page: 1,
      itemPerPage: 20
    }
  },
  computed: {
    ...mapGetters('alert', [
      'device'
    ]),
    ...mapGetters(['getSelectedPlantId', 'getGeneralState', 'getActivePlantInfo']),
    topic() {
      return `/alert/update/${this.getSelectedPlantId}/${
        this.device === 'all' ? '#' : this.device
      }`
    },
    activeFilter() {
      return this.getGeneralState('activeFilterOption')
    },
    activeDate() {
      return this.activeFilter.Date ? this.activeFilter.Date : {
        from: momentTz().tz(this.getActivePlantInfo("timezone")).format('YYYY-MM-DD'),
        to: momentTz().tz(this.getActivePlantInfo("timezone")).format('YYYY-MM-DD')
      }
    },
    activeServerity() {
      return this.activeFilter.severity ? this.activeFilter.severity : {
        text: 'Critical',
        value: 'critical'
      }
    },
    activeStatus() {
      return this.activeFilter.status ? this.activeFilter.status : { text: 'New', value: 'new' }
    },
    watchFilterChanges() {
      return `${this.activeDate.from} ${this.activeDate.to} ${this.activeServerity.value} ${this.activeStatus.value}`
    }
  },
  mounted() {
    this.fetchAlertLogs()
    EventBus.$on('alertPageNum', this.changePage)
    EventBus.$on('alertDownload', this.download)
    EventBus.$on('plantChanged', this.plantChange)
    this.$mqtt.subscribe(this.topic)
    this.$mqtt.on('message', (topic, message) => {
      if (topic.startsWith('/alert/update')) {
        this.appendNewAlert(JSON.parse(message.toString()))
      }
    })
    EventBus.$on('alert:update', this.showSnackbar)
  },
  beforeDestroy() {
    EventBus.$off('alertPageNum', this.changePage)
    EventBus.$off('alertDownload', this.download)
    EventBus.$off('plantChanged', this.plantChange)
    // Clear event listeners before destroying the component
    EventBus.$off('alert:update', this.showSnackbar)
    this.$mqtt.unsubscribe(this.topic)
  },
  methods: {
    ...mapActions('alert', [
      'fetchAlert',
      'downloadAlert',
      'appendNewAlert',
      'clear'
    ]),
    changePage(value) {
      this.page = value
      this.fetchAlertLogs()
    },
    fetchAlertLogs() {
      const param = {
        plantId: this.getSelectedPlantId,
        dateFrom: this.activeDate.from,
        dateTo: this.activeDate.to,
        device: this.device,
        severity: this.activeServerity.value,
        status: this.activeStatus.value,
        page: this.page,
        itemPerPage: this.itemPerPage
      }

      this.fetchAlert(param)
    },
    download() {
      const param = {
        plantId: this.getSelectedPlantId,
        plantName: this.getActivePlantInfo('plant_name'),
        dateFrom: this.activeDate.from,
        dateTo: this.activeDate.to,
        device: this.device,
        severity: this.activeServerity.value,
        status: this.activeStatus.value
      }
      this.downloadAlert(param)
    },
    plantChange() {
      this.clear()
      this.page = 1
      this.fetchAlertLogs()
    },
    showSnackbar(payload) {
      this.snackbarMessage = payload.message
      this.iconStatus = payload.status
      this.snackbar = true
      this.fetchAlertLogs()
    }
  },
  watch: {
    topic(newValue, oldValue) {
      this.$mqtt.unsubscribe(oldValue)
      this.$mqtt.subscribe(newValue)
    },
    watchFilterChanges() {
      this.page = 1
      this.fetchAlertLogs()
    }
  }
}
</script>

<style>
.section-width {
  min-width: 340px;
}
</style>
